import { apiFetch } from '@/lib/api-client/client';

/**
 * Matches GET /api/health's response shape exactly (apps/worker/src/routes/health.ts).
 *
 * Deliberately distinguishes "the website/API is online" from "the bot bridge
 * is configured/reachable" — not pretending the bot is connected when it
 * isn't. The Bot Bridge now exists (bridge/server.py); `botBridge.configured`
 * reflects whether this deployment has BOT_BRIDGE_URL/BOT_BRIDGE_SHARED_SECRET
 * set, and `reachable` reflects a real signed health check against it.
 */
export interface HealthResponse {
  status: 'ok';
  service: 'dem-web-api';
  timestamp: string;
  environment: string;
  botBridge: {
    configured: boolean;
    reachable: boolean | null;
    note: string;
  };
}

export function getHealth(): Promise<HealthResponse> {
  return apiFetch<HealthResponse>('/api/health');
}
